<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="server"/>
          {{ $t('gateway') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="filterFormModel.status" @input="load">
          <b-tab :title="$t('activated')"></b-tab>
          <b-tab :title="$t('deactivated')"></b-tab>
        </b-tabs>
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('keyword')"></b-form-input>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <p class="pull-left" v-if="itemCount">{{ $t('found', [itemCount]) }}</p>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" v-model="filterFormModel.page"
                      :total-rows="itemCount" :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
        <button @click="create" class="btn btn-sm btn-success pull-right"
                v-if="['admin', 'owner', 'tech'].includes($store.state.user.role)">
          <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
        </button>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-2">{{ $t('name') }}</div>
            <div class="col-lg-2">{{ $t('proxy') }}</div>
            <div class="col-lg-2">{{ $t('desc') }}</div>
            <div class="col-lg-4">{{ $t('status') }}</div>
            <div class="col-lg-2"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-2">
              <b class="c-smart-table__label">{{ $t('name') }}: </b>
              <span><b>Id: </b>{{ item._id }}</span>
              <span><b>{{ $t('name' )}}: </b>{{ item.name }}</span>
              <span v-if="item.country"><label class="badge badge-info">{{ item.country.name }}</label></span>
              <span v-if="item.default"><label class="badge badge-primary">{{ $t('default') }}</label></span>
            </div>
            <div class="col-lg-2">
              <b class="c-smart-table__label">{{ $t('proxy') }}: </b>
              <span>{{ item.proxy }}</span>
            </div>
            <div class="col-lg-2">
              <b class="c-smart-table__label">{{ $t('desc') }}: </b>
              <span>{{ item.desc ? item.desc : $t('notUpdated') }}</span>
            </div>
            <div class="col-lg-4">
              <p>
                <span v-if="item.active" class="badge badge-success">{{ $t('activated') }}</span>
                <span v-if="!item.active" class="badge badge-danger">{{ $t('deactivated') }}</span>
              </p>
              <p>
                <span>RTP rewrite timestamps: </span>
                <span v-if="item.RTPRewriteTimestamps" class="badge badge-success">{{ $t('yes') }}</span>
                <span v-else class="badge badge-danger">{{ $t('no') }}</span>
              </p>
              <p>
                <span>Codecs: </span>
                <b v-if="item.codecs && item.codecs.length">{{ item.codecs.join(', ') }}</b>
                <span v-else class="text-danger">{{ $t('notUpdated') }}</span>
              </p>
              <p>
                <span>Video enabled: </span>
                <span v-if="item.videoEnabled" class="badge badge-success">{{ $t('yes') }}</span>
                <span v-else class="badge badge-danger">{{ $t('no') }}</span>
              </p>
              <p v-if="item.videoEnabled">
                <span>Video codecs: </span>
                <b v-if="item.videoCodecs && item.videoCodecs.length">{{ item.videoCodecs.join(', ') }}</b>
                <span v-else class="text-danger">{{ $t('notUpdated') }}</span>
              </p>
            </div>
            <div class="col-lg-2">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col" v-if="['admin', 'owner', 'tech'].includes($store.state.user.role)">
                    <button @click="update(item._id)" type="button" class="btn btn-sm btn-info mr-1">
                      <font-awesome-icon icon="edit"/>&nbsp;{{ $t('edit') }}
                    </button>
                    <button @click="del(item._id)" type="button" class="btn btn-sm btn-danger mr-1">
                      <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <p class="pull-left">{{ $t('found', [itemCount]) }}</p>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" v-model="filterFormModel.page"
                      :total-rows="itemCount" :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
      </div>
    </div>

    <b-modal v-model="showForm" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
      <div class="col-md">
          <div class="alert alert-warning">
            <div><b>Lưu ý khi cập nhật gateway</b></div>
            <div>- Khi thêm mới gateway sẽ chạy drouting reload <span class="text-danger">toàn bộ routing nodes</span>, nên thận trọng chọn thời điểm để cập nhật</div>
          </div>
        </div>
      <country-select :label="$t('country')" :model="formModel" :errors="formErrors"></country-select>
      <form-input :label="$t('name')" :model="formModel" attribute="name" :errors="formErrors"></form-input>
      <form-input :label="$t('desc')" :model="formModel" attribute="desc" :errors="formErrors"></form-input>

      <div class="row">
        <div class="col-md">
          <form-checkbox chk-label="From number prefix enabled" :model="formModel" attribute="fromNumberPrefixEnabled"
                         :errors="formErrors" class="mt-2"></form-checkbox>
        </div>
        <div class="col-md">
          <form-input v-if="formModel.fromNumberPrefixEnabled" placeholder="From number prefix" :model="formModel"
                      attribute="fromNumberPrefix" :errors="formErrors"></form-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md">
          <form-checkbox chk-label="To number prefix enabled" :model="formModel" attribute="toNumberPrefixEnabled"
                         :errors="formErrors" class="mt-2"></form-checkbox>
        </div>
        <div class="col-md">
          <form-input v-if="formModel.toNumberPrefixEnabled" placeholder="To number prefix" :model="formModel"
                      attribute="toNumberPrefix" :errors="formErrors"></form-input>
        </div>
      </div>
      <form-input label="From number strip" :model="formModel"
                  attribute="fromNumberStrip" :errors="formErrors"></form-input>
      <form-input label="To number strip" :model="formModel"
                  attribute="fromNumberStrip" :errors="formErrors"></form-input>
      <form-input :label="$t('proxy')" :model="formModel" attribute="proxy" :errors="formErrors"></form-input>
      <form-proxies label="Proxies" :model="formModel" attribute="proxies" :errors="formErrors"></form-proxies>
      <form-input :label="$t('fromDomain')" :model="formModel" attribute="fromDomain" :errors="formErrors"></form-input>
      <form-checkbox :chk-label="$t('callerIdInFrom')" :model="formModel" attribute="callerIdInFrom"
                     :errors="formErrors"></form-checkbox>
      <form-checkbox chk-label="RTP rewrite timestamps" :model="formModel" attribute="RTPRewriteTimestamps"
                     :errors="formErrors"></form-checkbox>
      <form-checkbox-group label="Codecs" :model="formModel" attribute="codecs" :errors="formErrors"
                           :options="codecOptions"></form-checkbox-group>
      <hr>
      <form-checkbox chk-label="Video enabled" :model="formModel" attribute="videoEnabled"
                     :errors="formErrors"></form-checkbox>
      <form-checkbox-group v-if="formModel.videoEnabled" label="Video codecs" :model="formModel" attribute="videoCodecs"
                           :errors="formErrors" :options="videoCodecOptions"></form-checkbox-group>
      <form-checkbox :chk-label="$t('register')" :model="formModel" attribute="register"
                     :errors="formErrors"></form-checkbox>
      <template v-if="formModel.register">
        <form-input :label="$t('username')" :model="formModel" attribute="username" :errors="formErrors"></form-input>
        <form-input :label="$t('password')" :model="formModel" attribute="password" :errors="formErrors"></form-input>
      </template>
      <form-checkbox :chk-label="$t('domainInHeader')" :model="formModel" attribute="domainInHeader"
                     :errors="formErrors"></form-checkbox>
      <form-checkbox :chk-label="$t('activated')" :model="formModel" attribute="active"
                     :errors="formErrors"></form-checkbox>
      <form-checkbox :chk-label="$t('default')" :model="formModel" attribute="default"
                     :errors="formErrors"></form-checkbox>
      <form-input :label="$t('defaultNumber')" :model="formModel" attribute="defaultNumber" :errors="formErrors"></form-input>
    </b-modal>
  </main>
</template>

<script>
import List from '../../mixins/List';
import CRUD from "../../mixins/CRUD";
import CountrySelect from "@/components/CountrySelect";
import FormProxies from "@/components/FormProxies";

export default {
  components: {CountrySelect, FormProxies},
  mixins: [List, CRUD],
  data() {
    return {
      showList: false,
      service: 'gateway',
      defaultFormModel: {
        country: null,
        fromNumberPrefixEnabled: false,
        toNumberPrefixEnabled: false,
        fromNumberPrefix: null,
        toNumberPrefix: null,
        fromNumberStrip: null,
        toNumberStrip: null,
        active: true,
        default: false,
        defaultNumber: null,
        RTPRewriteTimestamps: false,
        codecs: ['PCMA', 'PCMU'],
        videoEnabled: false,
        videoCodecs: ['H264', 'H263'],
        proxies: [],
        register: false,
        domainInHeader: false
      },
      codecOptions: ['OPUS', 'G7221', 'G722', 'PCMA', 'PCMU', 'GSM'],
      videoCodecOptions: ['H265', 'H264', 'H263']
    }
  },
  i18n: {
    messages: {
      en: {
        gateway: 'Gateway',
        title: 'Gateways list',
        proxy: 'Proxy',
        fromDomain: 'From domain',
        callerIdInFrom: 'Caller id in from',
        register: 'Register',
        fromNumberPrefix: 'From number prefix',
        fromNumberPrefixEnabled: 'From number prefix enabled',
        toNumberPrefix: 'To number prefix',
        toNumberPrefixEnabled: 'To number prefix enabled',
        default: 'Default',
        defaultNumber: 'Default number',
        domainInHeader : "Domain in header"
      },
      vi: {
        gateway: 'Gateway',
        title: 'Danh sách gateway',
        proxy: 'Proxy',
        fromDomain: 'From domain',
        callerIdInFrom: 'Caller id in from',
        register: 'Đăng ký',
        fromNumberPrefix: 'Tiền tố vào số gọi ra',
        fromNumberPrefixEnabled: 'Thêm tiền tố vào số gọi ra',
        toNumberPrefix: 'Tiền tố vào số gọi vào',
        toNumberPrefixEnabled: 'Thêm tiền tố vào số gọi vào',
        default: 'Mặc định',
        defaultNumber: 'Số mặc định',
        domainInHeader : "Domain trong header"
      }
    }
  },
  methods: {
    list() {
      this.showList = true;
    },
  }
}
</script>